module.exports = __webpack_public_path__ + "static/click_to_pay_monei-db1d1f3875335210cebfd94f980b2a86.svg";